import { render } from "./Avatar.vue?vue&type=template&id=5812f7dc&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=5812f7dc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5812f7dc"

export default script